import React, { useEffect, useState, useMemo } from "react";
import "../../scss/dashboard/dashSettings.css";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useQuery, useMutation } from "react-query";

import SettingTax from "./settings/Tax";
import { useFormik } from "formik";
import Select from "react-select";
import {
  Row,
  Col,
  Input,
  Label,
  Form,
  FormText,
  FormGroup,
  FormFeedback,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Progress,
} from "reactstrap";
import MaskedInput, { conformToMask } from "react-text-mask";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { languages, storageOptions } from "../../config";
import LoadingButton from "../LoadingButton";
import InputWithLoader from "../InputWithLoader";
import { phoneMask, maskPhone, unmaskPhone } from "../../utils";
import { fetchProfile, updateProfile } from "../../api/actions/profile";
import { useProfile, useUpdateProfile } from "../../api/hooks/profile";
import { fetcher } from "../../api/client";
import PhoneNumberInput from "../PhoneNumberInput";

export const ProfileSchema = Yup.object().shape({
  givenName: Yup.string().required("Required"),
  familyName: Yup.string().required("Required"),
  representative: Yup.string(),
  companyName: Yup.string(),
  email: Yup.string().email("InvalidEmail"),
  phone: Yup.string(),
  language: Yup.string(),
  saveDocumentsOn: Yup.string(),
  clabe: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(18, "Must be exactly 18 digits")
    .max(18, "Must be exactly 18 digits"),
});

export function BasicData({
  onSubmit,
  onChange,
  isSubmitting,
  hideEmail = false,
  hidePhone = false,
  formik: { values, errors, touched, handleChange },
  formToUse,
}) {
  return (
    <Form onSubmit={onSubmit} noValidate>
      <h2>Información</h2>
      <Row>
        <Col lg={6} sm={6} className="mb-3">
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>Nombre</span>
            </Label>

            <InputWithLoader
              id="givenName"
              className="form-control dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="givenName"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.givenName}
              invalid={errors.givenName && touched.givenName}
            />
          </FormGroup>
        </Col>

        {!hideEmail && (
          <Col lg={6} sm={6} className="mb-3">
            <FormGroup className="mb-0">
              <Label for="givenName" className="font-weight-bold">
                <span>Correo</span>
              </Label>

              <Input
                id="email"
                className="form-control dashSettingsInput"
                aria-describedby="emailHelp"
                type="email"
                name="email"
                disabled
                // loading={isSubmitting}
                onChange={handleChange}
                value={values.email}
                invalid={errors.email && touched.email}
              />
            </FormGroup>
          </Col>
        )}
        <Col lg={6} sm={6} className="mb-3">
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>Apellidos</span>
            </Label>

            <InputWithLoader
              id="familyName"
              className="form-control dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="familyName"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.familyName}
              invalid={errors.familyName && touched.familyName}
            />
          </FormGroup>
        </Col>
        {!hidePhone && (
          <Col lg={6} sm={6}>
            <FormGroup className="mb-xs-4">
              <Label for="givenName" className="font-weight-bold">
                <span>Número Celular</span>
              </Label>

              <PhoneNumberInput
                id="phone"
                className="dashSettingsInput"
                aria-describedby="emailHelp"
                type="text"
                name="phone"
                loading={isSubmitting}
                onChange={handleChange}
                value={values.phone}
                invalid={errors.phone && touched.phone}
              />
            </FormGroup>
          </Col>
        )}
      </Row>
      <h2 style={{ marginTop: "20px" }}>Detalles de Pago</h2>
      <Row>
        <Col lg={6} sm={6} className="mb-3">
          <FormGroup className="mb-xs-4">
            <Label for="name" className="font-weight-bold">
              <span>Tipo de Pago</span>
            </Label>

            <InputWithLoader
              id="paymentType"
              className="form-control dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="paymentType"
              loading={isSubmitting}
              onChange={handleChange}
              value={"Transferenica Bancaria"}
              disabled
              // invalid={errors.companyName && touched.companyName}
            />
          </FormGroup>
        </Col>
        <Col lg={6} sm={6} className="mb-3">
          <FormGroup className="">
            <Label for="representative" className="font-weight-bold">
              <span>Nombre del banco</span>
            </Label>

            <InputWithLoader
              id="bankName"
              className="form-control dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="bankName"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.bankName}
              // invalid={errors.representative && touched.representative}
            />
          </FormGroup>
        </Col>
        <Col lg={6} sm={6} className="mb-3">
          <FormGroup className="">
            <Label for="representative" className="font-weight-bold">
              <span>Cuenta CLABE</span>
            </Label>

            <InputWithLoader
              id="clabe"
              className="form-control dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="clabe"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.clabe}
              invalid={errors.clabe}
              // invalid={errors.representative && touched.representative}
            />
            <small className="text-danger" hidden={!errors?.clabe}>
              {"La cuenta CLABE es un número de 18 digitos"}
            </small>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
}
export function CompanyData({
  onSubmit,
  onChange,
  isSubmitting,
  hideEmail = false,
  hidePhone = false,
  formik: { values, errors, touched, handleChange },
  formToUse,
}) {
  return (
    <Form onSubmit={onSubmit} noValidate>
      <h2>Detalles de Empresa</h2>
      <Row>
        <Col lg={6} sm={6} className="mb-3">
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>Nombre</span>
            </Label>

            <InputWithLoader
              id="normalName"
              className="form-control dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="normalName"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.normalName}
              invalid={errors.givenName && touched.givenName}
            />
          </FormGroup>
        </Col>

        {!hideEmail && (
          <Col lg={6} sm={6} className="mb-3">
            <FormGroup className="mb-0">
              <Label for="givenName" className="font-weight-bold">
                <span>Razón Social</span>
              </Label>

              <Input
                id="companyName"
                className="form-control dashSettingsInput"
                aria-describedby="emailHelp"
                type="email"
                name="companyName"
                // loading={isSubmitting}
                onChange={handleChange}
                value={values.companyName}
              />
            </FormGroup>
          </Col>
        )}
        <Col lg={6} sm={6} className="mb-3">
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>Representante Legal</span>
            </Label>

            <InputWithLoader
              id="representative"
              className="form-control dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="representative"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.representative}
              invalid={errors.familyName && touched.familyName}
            />
          </FormGroup>
        </Col>

        <Col lg={6} sm={6}>
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>Telefono</span>
            </Label>

            <PhoneNumberInput
              id="companyPhone"
              className="dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="companyPhone"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.companyPhone}
              invalid={errors.phone && touched.phone}
            />
          </FormGroup>
        </Col>
        <Col lg={6} sm={6}>
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>Código Postal</span>
            </Label>

            <InputWithLoader
              id="postalCode"
              className="dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="postalCode"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.postalCode}
              invalid={errors.phone && touched.phone}
            />
          </FormGroup>
        </Col>
        <Col lg={6} sm={6}>
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>E-Mail Empresa</span>
            </Label>

            <InputWithLoader
              id="companyEmail"
              className="dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="companyEmail"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.companyEmail}
              invalid={errors.phone && touched.phone}
            />
          </FormGroup>
        </Col>
        <Col lg={12} sm={6}>
          <FormGroup className="mb-xs-4">
            <Label for="givenName" className="font-weight-bold">
              <span>Dirección Fiscal</span>
            </Label>

            <InputWithLoader
              id="fiscalDirection"
              className="dashSettingsInput"
              aria-describedby="emailHelp"
              type="text"
              name="fiscalDirection"
              loading={isSubmitting}
              onChange={handleChange}
              value={values.fiscalDirection}
              invalid={errors.phone && touched.phone}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
}
function parseData(data) {
  const office = data.office
    ? data.office
    : {
        name: "",
        businessName: "",
        representative: "",
        email: "",
        address: "",
        zipCode: "",
        phone: "",
        logo: "",
      };
  const bankData = data.bankData
    ? data.bankData
    : {
        name: "",
        standarizedBankCode: "",
      };
  return {
    ...data,
    representative: office?.representative || "",
    companyName: office?.name || "",
    normalName: office?.businessName || "",
    companyEmail: office?.email || "",
    fiscalDirection: office?.address || "",
    postalCode: office?.zipCode || "",
    companyPhone: office?.phone || "",
    bankName: bankData?.name || "",
    clabe: bankData?.standarizedBankCode || "",

    phone: maskPhone(data.phone),
  };
}

function DashSettingsForm({ toggle, requiredForm, imageURl, uploadImageSrc }) {
  const { profile, isLoading } = useProfile();
  const { mutate: mutateUpdateProfile, ...updateProfileState } =
    useUpdateProfile();

  const { handleSubmit, isSubmitting, ...formik } = useFormik({
    initialValues: parseData(profile),

    onSubmit: async (values, actions) => {
      const newProfile = {
        ...values,

        office: {
          name: values.companyName,
          businessName: values.normalName,
          representative: values.representative,
          email: values.companyEmail,
          address: values.fiscalDirection,
          zipCode: values.postalCode,
          phone: values.companyPhone,
          logo: imageURl,
        },
        bankData: {
          name: values.bankName,
          standarizedBankCode: values.clabe,
        },

        phone: unmaskPhone(values.phone),
      };

      mutateUpdateProfile(newProfile, {
        onSuccess: () => toggle(),
      });
      actions.setSubmitting();
    },
    validationSchema: ProfileSchema,
    enableReinitialize: true,
  });
  useEffect(() => {
    if (imageURl && imageURl !== "" && uploadImageSrc === true) {
      handleSubmit();

      console.log("Image Uploaded");
    }
  }, [imageURl]);

  return (
    <div className="Setting__firstContainer">
      <div className="Settings__Form">
        {requiredForm === "personal" ? (
          <BasicData
            formik={formik}
            isSubmitting={isSubmitting || isLoading}
            onSubmit={handleSubmit}
          />
        ) : (
          <CompanyData
            formik={formik}
            isSubmitting={isSubmitting || isLoading}
            onSubmit={handleSubmit}
          />
        )}
        <div className="">
          <LoadingButton
            type="submit"
            color="accent-100"
            onClick={handleSubmit}
            className="btn btn-accent-100 mt-2"
            loading={isSubmitting || isLoading || updateProfileState.isLoading}
          >
            Guardar
          </LoadingButton>
        </div>
      </div>
    </div>
  );
}
export default DashSettingsForm;
